export default __webpack_public_path__ + "static/media/privacy.70017ce5.md";